const routes = {
  shifts: 'School Hours',
  passengers: 'Students'
};

export default routes;
